<template>
    <section class="container-contact">
        <div class="container">
        <div class="row">
            <div class="col-md-7">
            <p class="gca-title-big">Si tienes dudas es un gusto para nosotros asesorarte personalmente</p>
            <p class="gca-text">Llámanos o escríbenos por Whatsapp para mayores informes</p>
            <p class="gca-text"><i class="fab fa-whatsapp fa-2x"></i> <a href="https://wa.me/5217222202654?text=Me%20gustaría%20conocer%20el%20más%20de%20las%20certificaciones" target="_blank" class="a-link">+52 722 220 2654</a></p>
            <p class="gca-text">Envíanos tus dudas por el formulario y con gusto nos pondremos en contacto.</p>
            <p class="gca-text">También puedes encontrarnos en:</p>
            <p class="gca-text">Ceboruco 2511, Real de San Javier, Metepec, México 52169</p>
            </div>
            <div class="col-md-5">
            <div class="card bg-form">
                <vue-form :state="formstate2" @submit.prevent="sendlead()">
                <div class="card-body">
                    <div class="row">
                    <h3 class="card-title" style="font-family: Lato;">Informes</h3>
                    <div class="mb-3">
                        <validate tag="div">
                            <input type="text" v-model="model.nombre" class="form-control" id="sName" name="sName" placeholder="Nombre" required>
                            <field-messages name="sName" show="$invalid && $submitted" class="text-danger">
                                <div slot="required">El nombre es requerido</div>
                            </field-messages>
                        </validate>
                    </div>
                    <div class="mb-3">
                        <validate tag="div">
                            <input type="text" v-model="model.apellidos" class="form-control" id="sLastName" name="sLastName" placeholder="Apellido" required>
                            <field-messages name="sLastName" show="$invalid && $submitted" class="text-danger">
                                <div slot="required">Los apellidos son requeridos</div>
                            </field-messages>
                        </validate>
                    </div>
                    <div class="mb-3">
                        <validate tag="div">
                            <input  type="email" v-model="model.email" class="form-control" id="sEmail" name="sEmail" placeholder="Correo electrónico" required>
                            <field-messages name="sEmail" show="$invalid && $submitted" class="text-danger">
                                <div slot="required">El correo electrónico es requerido</div>
                                <div slot="email">El correo electrónico no es válido</div>
                            </field-messages>
                        </validate>
                    </div>
                    <div class="mb-3">
                        <validate tag="div">
                            <input type="text" v-model="model.telefono" class="form-control" id="sPhone" name="sPhone" placeholder="Teléfono de contacto" required>
                            <field-messages name="sPhone" show="$invalid && $submitted" class="text-danger">
                                <div slot="required">El Teléfono es requerido</div>
                            </field-messages>
                        </validate>
                    </div>
                    <div class="mb-3">
                        <validate tag="div">
                            <textarea v-model="model.comentarios" class="form-control" id="sComments" name="sComments" placeholder="Comentarios" rows="4" required></textarea>
                            <field-messages name="sComments" show="$invalid && $submitted" class="text-danger">
                                <div slot="required">Los comentarios es requerido</div>
                            </field-messages>
                        </validate>
                    </div>
                    <div class="mb-3">
                        <button type="submit" class="btn btn-primary float-end">ENVIAR</button>
                    </div>
                    </div>
                </div>
                </vue-form>
            </div>
            </div>
        </div>
        </div>
    </section>
</template>
<script>
	import options from "../../validations/validations.js";
	Vue.use(VueForm, options);
	export default {
		components: {
		},    
		name: 'LeadComponent',
		data() {
			return {
				formstate2: {},
                model: {
                    nombre: null,
                    apellidos: '',
                    email: '',
                    telefono: '',
                    comentarios: '',
                    suscrito: 1,
                },
			}
		},
		methods: {
            async sendlead() {
                if (this.formstate2.$invalid) {
                    return
                }

                this.openLoading()
                await axios.post(apiKS + 'api/gca/leads', this.model, { headers: clientAPI })
                .then( response => {
                    Swal.close()
                    if (response.data.status == true) {
                        this.$router.push('/thankyou')
                        // Swal.fire({
                        //     title: "Exito",
                        //     text: response.data.message,
                        //     icon: "success",
                        // })
                    }
                    if (response.data.status == false) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: response.data.message,
                        })
                    }
                })
                .catch( error => {
                    this.catchError(error)
                })
		    },
        }
    }
</script>